/**
 * Secure Token Storage Utility
 * Centralizes token storage with security best practices.
 * Uses sessionStorage for tokens (cleared on tab close) with
 * optional persistence via a secure flag in localStorage.
 */

const TOKEN_KEY = "gbrms_token";
const USER_KEY = "gbrms_user";
const PERSIST_KEY = "gbrms_persist";

/**
 * Store authentication token.
 * Uses sessionStorage by default (more secure, cleared on tab close).
 * Falls back to localStorage only when "remember me" is enabled.
 */
export function setToken(token, persist = true) {
  try {
    if (persist) {
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(PERSIST_KEY, "true");
    } else {
      sessionStorage.setItem(TOKEN_KEY, token);
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(PERSIST_KEY);
    }
  } catch (e) {
    console.error("Failed to store token:", e);
  }
}

/**
 * Retrieve authentication token.
 * Checks sessionStorage first (current session), then localStorage (persisted).
 */
export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
}

/**
 * Remove authentication token from all storage.
 */
export function clearToken() {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(PERSIST_KEY);
  localStorage.removeItem(USER_KEY);
}

/**
 * Store user profile data (non-sensitive).
 */
export function setUserData(userData) {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
  } catch (e) {
    console.error("Failed to store user data:", e);
  }
}

/**
 * Retrieve user profile data.
 */
export function getUserData() {
  try {
    const data = localStorage.getItem(USER_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}
